import React from 'react';

import bottomBorderImage from 'src/client/assets/images/withLove/letter-modal-border.png';
import risingMajorityAuthorImage from 'src/client/assets/images/withLove/rising-majority-author.png';

import { Box } from 'src/client/components';

import { OrganizationCard } from '../../types';

import * as S from './styles';

type Props = {
  open: boolean;
  card: OrganizationCard | null;
  onClose: () => void;
  onReadAnother: () => void;
  onVisitOrg: () => void;
};

function LetterModal({
  open,
  card,
  onClose,
  onReadAnother,
  onVisitOrg,
}: Props) {
  if (!card) {
    return null;
  }

  const subtitle = `From: ${card.authorName}, ${card.authorTitle} - A note for you`;

  return (
    <S.StyledModal
      closable
      footer={null}
      open={open}
      width={1052}
      onCancel={onClose}
    >
      <S.Container>
        <S.Header>
          <S.LogoWrapper>
            <S.Logo alt={`${card.name} logo`} src={card.logoUrl} />
          </S.LogoWrapper>
          <S.HeaderText>
            <S.Title>{card.name}</S.Title>
            <S.Subtitle>{subtitle}</S.Subtitle>
          </S.HeaderText>
        </S.Header>

        <S.LetterContent>
          <p>Dear one,</p>
          <p>{card.welcomeMessage}</p>
          <p>
            As you continue, a wish I have for you Lorem ipsum dolor sit amet,
            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris
          </p>
        </S.LetterContent>

        <S.BottomSection>
          <S.SignatureSection>
            <S.AuthorImage
              alt={card.authorName}
              src={risingMajorityAuthorImage}
            />
            <S.SignatureText>
              <S.SignaturePrefix>With love,</S.SignaturePrefix>
              <S.AuthorName>{card.authorName}</S.AuthorName>
            </S.SignatureText>
          </S.SignatureSection>

          <S.ButtonsContainer>
            <S.ReadAnotherButton onClick={onReadAnother}>
              Read Another Note
            </S.ReadAnotherButton>
            <S.VisitOrgButton onClick={onVisitOrg}>
              Visit {card.name}
            </S.VisitOrgButton>
          </S.ButtonsContainer>
        </S.BottomSection>
      </S.Container>

      <Box padding="0 0 60px 0">
        <img alt="bottom border" src={bottomBorderImage} />
      </Box>
    </S.StyledModal>
  );
}

export default LetterModal;
